import { School } from "lucide-react";
import { useUser } from "@/contexts/UserContext";
import { CustomerPortalOverview } from "./CustomerPortalOverview";

/**
 * Página de teste, fora do menu, para validar a Visão financeira e a Evolução
 * dos pedidos com dados reais de produção. Depois de validado, o painel volta
 * para o Dashboard e esta página é removida.
 */
const CustomerPortalOverviewTest = () => {
  const { selectedClient, selectedCycleYear } = useUser();

  return (
    <div className="min-h-screen bg-muted/50 pb-16">
      <main className="container mx-auto max-w-6xl px-6 py-10">
        {selectedClient ? (
          <CustomerPortalOverview
            clientCode={selectedClient.codigo_cnx}
            initialCycleYear={selectedCycleYear}
          />
        ) : (
          <div className="py-24 text-center bg-white rounded-2xl border border-dashed border-border shadow-sm">
            <School className="h-10 w-10 text-muted-foreground/40 mx-auto mb-4" />
            <h3 className="text-xl font-bold text-foreground tracking-tight">
              Unidade escolar não selecionada
            </h3>
            <p className="text-muted-foreground text-sm font-medium">
              Selecione uma unidade no topo para visualizar os valores.
            </p>
          </div>
        )}
      </main>
    </div>
  );
};

export default CustomerPortalOverviewTest;
